module.exports = __webpack_public_path__ + "static/data-bd37728b89959e70c980569be67d6b05.png";